import React, { FC } from 'react'
import { FlexRow } from 'components/Flex'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  amount: number
}

const PrintOrderAmount: FC<Props> = (props) => {
  const { amount } = props
  return (
    <FlexRow justifyContent={'end'}>
      <span className={`${text.font_medium} ${text.font_bold}`}>売上（税込） :</span>
      <Spacer size={24} />
      <span className={`${text.font_medium} ${text.font_bold}`}>{amount.toLocaleString()}円</span>
    </FlexRow>
  )
}

export default PrintOrderAmount
